import { Component, OnInit } from '@angular/core';

@Component
({
  selector: 'device-service-page',
  templateUrl: './device.service.page.html',
  styleUrls: ['./device.service.page.scss']
})

export class DeviceServicePage implements OnInit 
{
  constructor() {}

  ngOnInit(): void {}
}
